// The language versions of a page, grouped (packages/shared/src/globals.ts, which has no dependencies). The panel and
// the API decide it with the same code.
import { type PageFamily, pageFamilies } from '../../../packages/shared/src/globals';
import type { ScannedPage } from './api';

export { type PageFamily, primaryLanguage } from '../../../packages/shared/src/globals';

/** The pages of a scan grouped by language: one family per page, with its versions (the main one first). */
export function scannedFamilies(pages: ScannedPage[]): PageFamily<ScannedPage>[] {
  const byKey = new Map(pages.map((page) => [page.key, page]));
  return pageFamilies(pages.map((page) => ({ key: page.key, url: page.finalUrl, lang: page.lang }))).map(
    (family) => ({
      key: family.key,
      members: family.members.flatMap((member) => byKey.get(member.key) ?? []),
    }),
  );
}
